const companySearchRouter = {
    path: "company-search",
    name: "company-search",
    meta: {
        title: "项目搜索"
    },
    redirect: {
        name: "company-search-list"
    },
    component: () => import("@/pages/index/home/projectSearch/CompanySearch"),
    children: [
        {
            path: "company-search-list",
            name: "company-search-list",
            meta: {
                title: "项目搜索-列表页"
            },
            component: () => import("@/pages/enterprise/list/Index")
        }
    ]
};
export default companySearchRouter;



// WEBPACK FOOTER //
// ./src/router/index/home/company_search.js